/* eslint-disable react-hooks/exhaustive-deps */
// src/pages/profile/Profile.js
import React, { useState, useEffect } from "react";
import Toast from "../../../components/common/Toast";
import api from "../../../api/axios";

export default function AssignRepModel({ onSelect, closeModal }) {
  const [selectedRepId, setSelectedRepId] = useState(null);
  const [filters] = useState({
    query: "",
    createdFrom: "",
    createdTo: "",
  });

  const [searchQuery] = useState(filters.query || "");
  const [includeInactive] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [meta, setMeta] = useState({ total: 0, page: 1, limit: 10 });
  const [users, setUsers] = useState([]);
  const [sortConfig] = useState({ column: "name", direction: "asc" });

  const [toast, setToaster] = useState({
    message: '',
    type: 'success',
    visible: false
  });

  useEffect(() => {
    fetchUsers();

  }, [searchQuery, page, pageSize, sortConfig, includeInactive]);

  const fetchUsers = async () => {
    const params = {
      q: searchQuery || undefined,
      page,
      limit: pageSize,
      sortBy: sortConfig.column,
      sortOrder: sortConfig.direction
    };

    const { data } = await api.get("/users/get-associate-rep", { params });

    setUsers(
      (data?.data ?? []).map((u) => ({
        id: u.id,
        name: u.name,
        email: u.email,
        address: u.address ?? "",
        phone: u.phone,
        titleRepId: u.titleRepId,
        title: u.title,
      }))
    );

    setMeta(data?.meta || {});
  };

  const handleSelectData = () => {
    if (!selectedRepId) {
      setToaster({ message: "Please select a rep first", type: 'error', visible: true });
      setTimeout(() => {
        setToaster((prev) => ({ ...prev, visible: false }));
      }, 2000);
      return;
    }

    const selectedUser = users.find((u) => u.id === selectedRepId);

    if (typeof onSelect === "function") {
      onSelect(selectedUser);
    }

    closeModal();
  };


  function getPaginationRange(totalPages, currentPage) {
    if (totalPages <= 3) return [...Array(totalPages)].map((_, i) => i + 1);
    if (currentPage === 1) return [1, 2, 3];
    if (currentPage === totalPages) return [totalPages - 2, totalPages - 1, totalPages];
    return [currentPage - 1, currentPage, currentPage + 1];
  }


  /** ✅ Render */
  return (
    <>
      <div class="tbl-type-a">
        <div class="open-tbl-section">
          <div class="table-overflow associate-rep-tbl">
            <table>
              <thead>
                <tr>
                  <th className="ass-select">Select</th>
                  <th className="ass-name">Name</th>
                  <th className="ass-address">Address</th>
                  <th className="ass-phone">Phone</th>
                  <th className="ass-email">Email</th>
                </tr>
              </thead>
              <tbody>
                {users.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No users found
                    </td>
                  </tr>
                ) : (
                  users.map((user) => (
                    <tr key={user.id}>
                      <td className="ass-select">
                        <input
                          type="radio"
                          name="selectedRep"
                          checked={selectedRepId === user.id}
                          onChange={() => setSelectedRepId(user.id)}
                        />
                      </td>
                      <td className="ass-name">
                        {user.name}<br />
                        <spam className="type-grey">Type:</spam> {user.title}
                      </td>
                      <td className="ass-address">{user.address}</td>
                      <td className="ass-phone">{user.phone}</td>
                      <td className="ass-email">{user.email}</td>
                    </tr>
                  ))
                )}


              </tbody>
            </table>
          </div>

          <div class="open-pagination pagination-desktop user-manage-pag">
            <nav class="pagination">

              <button
                disabled={page === 1}
                className={`page prev ${page === 1 ? "is-disabled" : ""}`}
                onClick={() => setPage(page - 1)}
              >
                Prev
              </button>

              {getPaginationRange(meta.totalPages ?? 1, page).map((p) => (
                <button
                  key={p}
                  className={`page ${page === p ? "is-active" : ""}`}
                  onClick={() => setPage(p)}
                >
                  {p}
                </button>
              ))}

              <button
                disabled={page === meta.totalPages}
                className={`page next ${page === meta.totalPages ? "is-disabled" : ""}`}
                onClick={() => setPage(page + 1)}
              >
                Next
              </button>

            </nav>
          </div>

          <div className="full-width-container-btn associate-rep-save">
            <div className="left-btn-container">

              <button type="button" className="submit-btn btn-bg inpt-btn w-120 discard-btn"
                onClick={closeModal}> Discard
              </button>

            </div>
            <div className="right-btn-container">
              <button type="submit" className="submit-btn btn-bg inpt-btn w-190" onClick={handleSelectData}>
                Select
              </button>
            </div>

             <Toast message={toast.message} type={toast.type} visible={toast.visible} />

          </div>
        </div>
      </div>
    </>
  );
}
